import { funnelDetailValues } from "@/constants/funnelRouteDeclareValues";
import { sessionStorage, storageKeys } from "@/utils/storage";

const useFunnelRouteDeclare = ({ uniqueKey }: { uniqueKey: string }) => {
  const { paths, product } = funnelDetailValues[uniqueKey];

  const sessionStoredFunnels = JSON.parse(
    sessionStorage.get(storageKeys.generalFunnels) || "{}"
  );
  if (sessionStoredFunnels.key !== uniqueKey) {
    sessionStorage.remove(storageKeys.generalFunnels);
    sessionStorage.set(
      storageKeys.generalFunnels,
      JSON.stringify({
        key: uniqueKey,
        paths,
        product,
      })
    );
  }
  return { paths, product };
};

export default useFunnelRouteDeclare;
